module.exports = __webpack_public_path__ + "static/media/Plus.2eebb97e.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/Plus.PNG
// module id = 1648
// module chunks = 1